module.exports = __webpack_public_path__ + "static/img/46.e13a1ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/Office365Deployment/46.png
// module id = 2Shq
// module chunks = 1